/* Liefertermin in der Kaufbox — rechnet die Lieferspanne in echte Daten um.

   Hängt sich direkt unter den Kauf-Knopf (#cfg-cta). Die Zeile „Handarbeit,
   Lieferung in 7–12 Tagen" weiter unten bleibt bewusst stehen: sie sagt
   dasselbe, nur als Spanne statt als Datum.

   Gerechnet wird aus derselben Spanne, die auch auf der Versandseite, in der FAQ
   und in den AGB steht: Fertigung 7–12 Tage (Kalendertage), danach 1–3 Werktage
   Versand. Damit sagt die Zeile nichts Neues zu — sie rechnet es dem Kunden nur vor.

   Einstellungen kommen aus window.CL_LIEFER (für die Vorschau umschaltbar):
     fertigungVon / fertigungBis – Fertigungsspanne in Tagen (7 / 12)
     versandVon / versandBis     – Versandspanne in Werktagen (1 / 3)
     alsSpanne – true zeigt „zwischen X und Y", false nur den spätesten Tag
     stil   – „a" schlicht · „b" hervorgehoben · „c" zweizeilig
     alteZeileAus – true blendet „Handgefertigt auf Bestellung" aus            */
(function () {
  'use strict';

  var STANDARD = {
    fertigungVon: 7,
    fertigungBis: 12,
    versandVon: 1,
    versandBis: 3,
    alsSpanne: true,
    stil: 'a',
    alteZeileAus: false
  };

  /* Ostersonntag nach der gregorianischen Osterformel — Grundlage für die vier
     beweglichen Feiertage.                                                      */
  function ostern(jahr) {
    var a = jahr % 19, b = Math.floor(jahr / 100), c = jahr % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var zahl = h + l - 7 * m + 114;
    return new Date(jahr, Math.floor(zahl / 31) - 1, (zahl % 31) + 1);
  }

  /* Nur die neun BUNDESWEITEN Feiertage. Landesfeiertage bleiben bewusst außen vor:
     sie verschieben höchstens um einen Tag und liegen damit innerhalb der Spanne —
     dafür stimmt die Rechnung unabhängig davon, wo gefertigt und wohin geliefert wird. */
  var feiertageJahr = {};
  function feiertage(jahr) {
    if (feiertageJahr[jahr]) return feiertageJahr[jahr];
    var o = ostern(jahr);
    var beweglich = [-2, 1, 39, 50].map(function (versatz) {
      var t = new Date(o.getFullYear(), o.getMonth(), o.getDate() + versatz);
      return t.getMonth() + '-' + t.getDate();
    });
    var fest = [[0, 1], [4, 1], [9, 3], [11, 25], [11, 26]].map(function (p) {
      return p[0] + '-' + p[1];
    });
    feiertageJahr[jahr] = fest.concat(beweglich);
    return feiertageJahr[jahr];
  }

  function istFeiertag(d) {
    return feiertage(d.getFullYear()).indexOf(d.getMonth() + '-' + d.getDate()) !== -1;
  }

  /* Kein Zustelltag: Sonntag und Feiertage. Samstag bleibt, weil DHL samstags liefert. */
  function ruhetag(d) {
    return d.getDay() === 0 || istFeiertag(d);
  }

  /* Fertigung zählt Kalendertage (Wochenenden sind in der 7–12-Spanne schon
     eingepreist). Fällt in den Zeitraum ein Feiertag auf einen Werktag, geht ein
     Arbeitstag verloren → einen Kalendertag dranhängen. Der Versand zählt danach
     Zustelltage.                                                                */
  function liefertag(fertigungstage, versandtage) {
    var d = new Date();
    var start = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    d.setDate(d.getDate() + fertigungstage);

    var geprueft = new Date(start);
    while (geprueft < d) {
      geprueft.setDate(geprueft.getDate() + 1);
      if (istFeiertag(geprueft) && geprueft.getDay() !== 0 && geprueft.getDay() !== 6) {
        d.setDate(d.getDate() + 1);
      }
    }

    var gezaehlt = 0;
    while (gezaehlt < versandtage) {
      d.setDate(d.getDate() + 1);
      if (!ruhetag(d)) gezaehlt++;
    }
    while (ruhetag(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function lang(d) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'long', day: 'numeric', month: 'long'
    }).format(d);
  }

  function kurz(d) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'short', day: 'numeric', month: 'short'
    }).format(d);
  }

  /* „12. und 19. August" — bei einer Spanne bewusst OHNE Wochentag: zwei Wochentage
     nebeneinander lesen sich holprig („zwischen Mittwoch, 12. und Mittwoch, 19.")
     und brechen auf dem Handy um. Der Monat steht nur einmal, solange beide Tage
     im selben Monat liegen.                                                     */
  function spanne(a, b) {
    var mitMonat = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' });
    /* Intl liefert bei day allein „12" ohne Punkt — der Ordnungspunkt muss dran. */
    var erster = a.getMonth() === b.getMonth() ? a.getDate() + '.' : mitMonat.format(a);
    return erster + ' und ' + mitMonat.format(b);
  }

  function paket() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 8v10a1 1 0 0 1-.6.9l-7.8 3.1a1.5 1.5 0 0 1-1.2 0L3.6 18.9A1 1 0 0 1 3 18V8"/>' +
      '<path d="M2 7.4 11.6 3.6a1.5 1.5 0 0 1 1.2 0L22 7.4 12.6 11.2a1.5 1.5 0 0 1-1.2 0z"/>' +
      '<path d="M12 11.4V22"/></svg>';
  }

  function zeichne(wunsch) {
    var einst = Object.assign({}, STANDARD, window.CL_LIEFER || {}, wunsch || {});
    var knopf = document.getElementById('cfg-cta');
    if (!knopf) return;

    var frueh = liefertag(einst.fertigungVon, einst.versandVon);
    var spaet = liefertag(einst.fertigungBis, einst.versandBis);
    var alt = document.getElementById('cl-lieferzeile');
    if (alt) alt.remove();

    var zeile = document.createElement('div');
    zeile.id = 'cl-lieferzeile';
    zeile.className = 'cl-lieferzeile cl-lz-' + einst.stil;

    var langText = einst.alsSpanne
      ? 'zwischen <b>' + spanne(frueh, spaet) + '</b>'
      : 'bis <b>' + lang(spaet) + '</b>';
    var kurzText = einst.alsSpanne
      ? 'zwischen ' + spanne(frueh, spaet)
      : 'bis ' + kurz(spaet);

    if (einst.stil === 'c') {
      zeile.innerHTML =
        '<span class="cl-lz-ic">' + paket() + '</span>' +
        '<span class="cl-lz-txt"><b>Voraussichtlich bei dir ' + kurzText + '</b>' +
        '<small>Handgefertigt auf Bestellung · kostenloser Versand</small></span>';
    } else {
      zeile.innerHTML =
        '<span class="cl-lz-ic">' + paket() + '</span>' +
        '<span class="cl-lz-txt">Voraussichtlich bei dir ' + langText + '</span>';
    }
    knopf.insertAdjacentElement('afterend', zeile);

    /* alte Zeile direkt unter dem Knopf */
    var urgency = document.querySelector('#buy .urgency');
    if (urgency) urgency.style.display = (einst.alteZeileAus || einst.stil === 'c') ? 'none' : '';

    /* Die Zeile „Handarbeit, Lieferung in 7–12 Tagen" im Vertrauens-Block bleibt
       bewusst unangetastet — sie sagt dasselbe wie das Datum oben, nur als Spanne. */
  }

  window.CL_LIEFER_ZEICHNE = zeichne;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { zeichne(); });
  } else {
    zeichne();
  }
})();
